import { useContext } from "react";
import {
  HeapAnalyticDataContext,
  PreBillAPIContext,
  PreBillContext,
} from "@app/provider";
import { HEAP_EVENTS } from "@app/provider/types";

interface TrackPreBillHeapEventProps {
  eventKey: HEAP_EVENTS;
}

const usePreBillHeapEvent = (): {
  trackPreBillHeapEvent: ({ eventKey }: TrackPreBillHeapEventProps) => void;
} => {
  const { drawRequestDataForHeapEventData } = useContext(
    HeapAnalyticDataContext
  );
  const {
    apiProviderState: { orderEstimate },
  } = useContext(PreBillAPIContext);
  const { notificationType, setPatientUid } = useContext(PreBillContext);

  if (drawRequestDataForHeapEventData?.identity) {
    setPatientUid(drawRequestDataForHeapEventData.identity);
  }

  const trackPreBillHeapEvent = ({ eventKey }: TrackPreBillHeapEventProps) => {
    const heapEventData = {
      notificationType,
      channel: orderEstimate?.channel,
      identity: drawRequestDataForHeapEventData?.identity,
      test_name: drawRequestDataForHeapEventData?.tests_ordered,
      lims_clinic_id: drawRequestDataForHeapEventData?.lims_clinic_id,
    };

    heap.track(eventKey, heapEventData);
  };

  return { trackPreBillHeapEvent };
};

export default usePreBillHeapEvent;
